import Klickart from './klickart';

export default class KlickartPage extends Klickart {
  constructor(config = {}) {
    config.path = 'partials/page_item';

    super(config);
  }

  page(pageIdentifier, params = {}) {
    return this.get(`${pageIdentifier}`, params);
  }
}



// WEBPACK FOOTER //
// ./src/services/request/klickartPage.js